module.exports = __webpack_public_path__ + "static/logomin-23b690002c44d17e8e7a1834da345b02.png";